'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.beginningOfMonth;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/beginningOfMonth.js
// module id = 166
// module chunks = 1